import { createFileRoute } from "@tanstack/react-router";
import { queryClient, trpc } from "~/utils/trpc";
import { ApplicationDetailsPage } from "./-pages/applicationIdPage";
import { useBreadCrumbs } from "~/contexts/useBreadCrumbs";
import { inferOutput } from "@trpc/tanstack-react-query";
import { RouteErrorComponent } from "@quake/shared-ui/components/ui/error-boundary";
import { getApplicationDocumentTitle, useDocumentTitle } from "~/utils/document-title";

export const Route = createFileRoute("/_dashboard/$datasetSlug/data/applications/list/$applicationId")({
  staleTime: 0,
  loader: async ({ params }) => {
    const application = await queryClient.fetchQuery(
      trpc.applications.getById.queryOptions({ id: params.applicationId }),
    );
    return { application };
  },
  component: ApplicationDetailsComponent,
  errorComponent: RouteErrorComponent,
});

type ApplicationDetails = inferOutput<typeof trpc.applications.getById>;

function ApplicationDetailsComponent() {
  const { application } = Route.useLoaderData() as { application: ApplicationDetails };
  const applicationTitle = getApplicationDocumentTitle(application);
  useDocumentTitle(applicationTitle, "Application");

  useBreadCrumbs([
    { title: "Applications", link: `/${location.pathname.split("/")[1]}/data/applications/list` },
    { title: applicationTitle, link: `/${location.pathname.split("/")[1]}/data/applications/list/${application?.id}` },
  ]);
  return <ApplicationDetailsPage application={application} />;
}
